export default class BottomBarHandler {
    private bar: HTMLElement | null;

    constructor(private readonly section) {
        this.bar = this.section.querySelector(".wrapper__box");
    }

    public init = async () => {
        if (!this.bar) return;

        this.listeners();
    };

    private handleScroll = () => {
        window.scrollY > 120 ? this.bar?.classList.add("scrolled") : this.bar?.classList.remove("scrolled");
    };

    private listeners = () => {
        window.addEventListener("scroll", this.handleScroll);
    };
}
